import { Engine } from 'excalibur';
import { Paddle } from './paddle';

export class AutoPaddle extends Paddle {
    constructor(engine: Engine) {
        super(engine);
        this.name = 'auto-paddle';
        this._speed = 1000;
    }

    override onPostUpdate(engine: Engine, elapsedMs: number): void {
        const ball = engine.currentScene.actors.find((actor) => actor.name === 'ball');
        if (ball) {
            if (ball.pos.x < this.pos.x) {
                this.pos.x -= this._speed * (elapsedMs / 1000);
            } else if (ball.pos.x > this.pos.x) {
                this.pos.x += this._speed * (elapsedMs / 1000);
            }
        }
    }

    override onInitialize(engine: Engine) { }
}
